export default "__VITE_ASSET__CPpwCeH$__"